<template>
    <div>
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1>Enquiry</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">Home</router-link>
                            </li>
                            <li class="breadcrumb-item active">Enquiry</li>
                        </ol>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Enquiry List</h3>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table projects">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 20%">Name</th>
                                    <th class="text-center" style="width: 20%">Email</th>
                                    <th class="text-center" style="width: 20%">Phone</th>
                                    <th class="text-center" style="width: 20%">Product</th>
                                    <th class="text-center" style="width: 20%">Message</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="allEnquiries.length">
                                    <tr v-for="(item, index) in allEnquiries" :key="'enquiry-list-' + index">
                                        <td class="text-center" style="width: 20%">{{ item.name ? item.name : '-' }}
                                        </td>
                                        <td class="text-center" style="width: 20%">{{ item.email ? item.email : '-' }}
                                        </td>
                                        <td class="text-center" style="width: 20%">{{ item.phone ? item.phone : '-' }}
                                        </td>
                                        <td class="text-center" style="width: 20%">
                                            {{ item.product ? item.product : '-' }}
                                        </td>
                                        <td class="text-center" style="width: 20%">{{ item.message ? item.message : '-'
                                        }}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="5" class="text-center">No enquiries available</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "Enquiry",
    data() {
        return {
            allEnquiries: []
        }
    },
    mounted() {
        this.getAllEnquiry();
    },
    methods: {
        getAllEnquiry() {
            axios.get('/api/enqueries')
                .then(response => {
                    this.allEnquiries = response.data;
                }).catch(error => {
                    console.error(error.response);
                });
        }
    }
}
</script>